import React, { useEffect, useState } from "react";
import { PageHeader, Card, Tag } from "../components/UI";
import DataTable from "../components/DataTable";
import { Shield } from "lucide-react";
import api from "../lib/api";

export default function Audit() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { (async () => { const { data } = await api.get("/audit?limit=500"); setLogs(data); })(); }, []);

  const events = [...new Set(logs.map((l) => l.event))].sort();

  const columns = [
    { key: "at", label: "Timestamp", filter: "text", render: (r) => new Date(r.at).toLocaleString() },
    { key: "event", label: "Event", filter: "select", options: events, render: (r) => <Tag tone="teal">{r.event}</Tag> },
    { key: "actor", label: "Actor", filter: "text", render: (r) => <span className="font-mono text-[11px]">{r.actor ? r.actor.slice(0, 12) : "system"}</span> },
    { key: "tenant_id", label: "Tenant", filter: "text", render: (r) => <span className="font-mono text-[11px]">{r.tenant_id ? r.tenant_id.slice(0, 8) : "—"}</span> },
    { key: "data", label: "Payload", sortable: false, render: (r) => <pre className="text-[10.5px] mono text-slate-600 max-w-md whitespace-pre-wrap break-all">{r.data ? JSON.stringify(r.data) : ""}</pre> },
  ];

  return (
    <div className="space-y-6">
      <PageHeader
        kicker="Compliance"
        title="Compliance & Audit"
        subtitle="An immutable timeline of every authentication, configuration change, transaction and approval — fully sortable, filterable and exportable for UCPMP review."
        testId="audit-page"
      />

      <Card>
        <DataTable columns={columns} data={logs} rowKey="id" searchableKeys={["event", "actor"]} exportFilename="cbc-audit" testIdPrefix="audit" initialSort={{ key: "at", dir: "desc" }} />
      </Card>
    </div>
  );
}
